<template>
  <div class="add_edit_free" v-loading="loading">
    <Form :label-width="100" label-position="right" :model="params" :rules="addRules" ref="feeForm">
      <FormItem label="企业名称" prop="custName" :class="{'custName': !addFlag}">
        <Select v-model="params.custName" @on-change="onChange" @on-open-change="onOpenChagne" v-if="addFlag">
          <Option v-for="(item, index) in resetOptions" :value="item.cust_name" :key="index">{{ item.cust_name }}</Option>
        </Select>
        <span class="itemSpan" v-else >{{params.custName}}</span>
      </FormItem>
      <FormItem label="企业编码">
        <span class="itemSpan">{{params.custNo}}</span>
      </FormItem>
      <FormItem label="企业类型">
        <span class="itemSpan">{{params.type === '1' ? '工业' : params.type === '2' ? '服务商' : ''}}</span>
      </FormItem>
      <FormItem label="企业域">
        <span class="itemSpan">{{params.companyDomain}}</span>
      </FormItem>
      <FormItem label="服务费" prop="data" class="fee">
          <Table :columns="columns" :data="params.data" style="width: 680px;" :border="true">
            <template slot-scope="{ row }" slot="rate">
              {{ row.rate + '%'}}
            </template>
            <template slot-scope="{ row, index }" slot="action">
              <span style='cursor: pointer; font-size:12px; color: #1881DC' @click="reset(row, index)">设置</span>
            </template>
          </Table>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="submit">确认提交</Button>
      </FormItem>
    </Form>
    <simpleDiag :isShow="isShow" :title="title" width="700px" class="feeDialog"
      @close="dialogClose" @confirm="dialogConfirm"
    >
      <div class="leibie">
        <span>推广大类：  {{diaServiceBig}}</span>
        <span class="right">推广子类：  {{diaServiceSmall}}</span>
      </div>
      <div class="add">
        <a class="add-company" @click="addTableData" href="javascript:;"><i class="yjh-icon icon-add"></i>新增</a>
      </div>
      <Table :columns="dialogColums" :data="dialogData" style="width: 100%;" :border="true" max-height="500">
        <template slot-scope="{ row, index }" slot="action">
          <span style='cursor: pointer; font-size:12px; color: #DE2F2F' @click="tableDetele(row, index)">删除</span>
        </template>
      </Table>
    </simpleDiag>
  </div>
</template>
<script>
import { getAccountFreeList, getAccountFreeDetail, getAccountTimeDetail, updateAccountFee } from '@/api/userManager.js'
import { msg } from '@/utils/index.js'
import simpleDiag from '@/components/dialogs/simpleDiag'
export default {
  name: '',
  components: { simpleDiag },
  data() {
    const checkData = (rule, value, cb) => {
      if (!value || !value.length) {
        cb(new Error('手续费不能为空'))
      } else {
        cb()
      }
    }
    return {
      searchValue: '', // 下拉框的搜索内容
      addFlag: true, // 新增还是编辑状态
      params: { // 全部替换为params
        custName: '', // 企业名称
        custNo: '', // 企业编码
        type: '', // 企业类型 1 工业 2服务商
        companyDomain: '', // 企业域
        data: [] // 表格数据
      },
      addRules: {
        custName: [
          { required: true, message: '企业名称不能为空', trigger: 'change' }
        ],
        data: [
          { required: true, validator: checkData }
        ]
      },
      options: [], // 新增情况下的选项集合
      columns: [ // 主页面table 数据
        {
          title: '服务大类',
          key: 'service_name',
          align: 'center'
        },
        {
          title: '服务子类',
          key: 'subd_name',
          align: 'center'
        },
        {
          title: '当前交易服务费',
          slot: 'rate',
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center'
        }
      ],
      isShow: false, // 是否展示弹框
      title: '设置', // 新增设置 编辑为编辑
      diaServiceBig: '',
      diaServiceSmall: '',
      diaServiceId: '',
      diaSubServiceId: '',
      dialogData: [ // 对话框table数据
        { start_time: '', end_time: '', service_rate: '' } // 新增的时候默认展示一个
      ],
      dialogColums: [ // 对话框table column
        {
          title: '有效期',
          align: 'center',
          width: 320,
          render: (h, params) => {
            return h('div', [
              h('DatePicker', {
                props: {
                  placeholder: '开始日期',
                  clearable: false,
                  editable: false,
                  type: 'date',
                  transfer: true,
                  value: this.dialogData[params.index].start_time
                },
                on: {
                  'on-change': (event) => {
                    // event 即为日期字符串值
                    const Flag = this.checkStartData(event, params.index)
                    if (Flag) {
                      this.dialogData[params.index].start_time = event
                    } else {
                      this.dialogData[params.index].start_time = event
                      this.$nextTick(() => {
                        this.dialogData[params.index].start_time = null
                      })
                    }
                  }
                },
                style: {
                  width: '120px'
                }
              }),
              h('span', {
                class: {
                  line: true
                }
              }),
              h('DatePicker', {
                props: {
                  placeholder: '结束日期',
                  clearable: false,
                  editable: false,
                  type: 'date',
                  transfer: true,
                  value: this.dialogData[params.index].end_time
                },
                style: {
                  width: '120px'
                },
                on: {
                  'on-change': (event) => {
                    // event 即为日期字符串值
                    // event 即为日期字符串值
                    const Flag = this.checkEndData(event, params.index)
                    if (Flag) {
                      this.dialogData[params.index].end_time = event
                    } else {
                      this.dialogData[params.index].end_time = event
                      this.$nextTick(() => {
                        this.dialogData[params.index].end_time = null
                      })
                    }
                  }
                }
              })
            ])
          }
        },
        {
          title: '交易服务费',
          key: 'service_rate',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Input', {
                props: {
                  type: 'text',
                  value: this.dialogData[params.index].service_rate
                },
                style: {
                  width: '80px'
                },
                on: {
                  'on-blur': (event) => {
                    if (event.target.value > 90) {
                      msg.call(this, '服务费不能超过90%')
                      this.dialogData[params.index].service_rate = 0
                    } else {
                      this.dialogData[params.index].service_rate = event.target.value
                    }
                  }
                }
              }),
              h('span', {
                style: {
                  verticalAlign: 'sub'
                }
              }, ' %')
            ])
          }
        },
        { title: '操作', align: 'center', slot: 'action' }
      ],
      loading: false
    }
  },
  computed: {
    resetOptions() {
      if (this.searchValue === '') {
        return this.options
      } else {
        const arr = this.options.filter(item => {
          return item.cust_name.indexOf(this.searchValue) !== -1
        })
        return arr
      }
    }
  },
  mounted() {
    const pageObj = { title: this.$route.params.id === 'add' ? '新增收费企业' : '编辑', type: 'cover' }
    pageObj.url = 'userFeeManger'
    this.$store.dispatch('setPage', pageObj)
    if (this.$route.params.id === 'add') { // 仅此一个其他的都是 数字
      this.addFlag = true
      this.title = '设置'
      this.getOptions()
    } else {
      this.addFlag = false
      this.title = '编辑'
      this.getEditData() // 只会获取table表格的数据
    }
  },
  methods: {
    getEditData() { // 编辑的时候获取主页的table数据
      this.loading = true
      getAccountFreeDetail({
        cust_no: this.$route.params.id
      }).then(res => {
        this.loading = false
        const { code, result } = res
        if (code === 0) {
          this.params.data = result.datas
          this.params.custName = result.cust_name
          this.params.custNo = result.cust_no
          this.params.type = result.type
          this.params.companyDomain = result.domain
        } else {
          this.$Message.info('获取编辑数据失败！')
        }
      })
    },
    getOptions() {
      getAccountFreeList({ // 后台没有写单独的接口 使用的是列表的接口
        current_page: 1,
        rp: 10000
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          this.options = result.data
        } else {
          this.options = []
          msg.call(this, '获取选项数据失败！')
        }
      })
    },
    onChange(value) {
      for (var i = 0; i < this.options.length; i++) {
        const item = this.options[i]
        if (item.cust_name === value) {
          this.getDetail(item.cust_no)
          this.params.custNo = item.cust_no
          this.params.type = item.type
          this.params.companyDomain = item.company_domain
          return ''
        }
      }
    },
    onOpenChagne(flag) {
    },
    getDetail(custNo) { // 新增 下拉操作 获取主页table数据
      getAccountFreeDetail({
        cust_no: custNo
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          this.params.data = result.datas
          this.$refs.feeForm.validateField('data')
        } else {
          this.params.data = []
        }
      })
    },
    reset(row, index) { // 设置不同时间的费用
      getAccountTimeDetail({
        cust_no: this.params.custNo,
        service_id: row.service_id,
        sub_service_id: row.subd_id
      }).then(res => {
        const { code, result } = res
        if (code === 0) {
          this.diaServiceBig = row.service_name
          this.diaServiceSmall = row.subd_name
          this.diaServiceId = row.service_id
          this.diaSubServiceId = row.subd_id
          this.isShow = true
          if (Object.prototype.toString.call(result) === '[object Object]') {
            this.dialogData = result[row.service_id][row.subd_id]
            // 返回的时间是 yy-mm-dd 00:00:00
          } else {
            // 返回的是空数组
            this.dialogData = [{ start_time: '', end_time: '', service_rate: '' }]
          }
        } else {
          msg.call(this, '没有获取到数据')
          this.dialogData = [{ start_time: '', end_time: '', service_rate: '' }]
        }
      })
    },
    tableDetele(row, index) {
      this.dialogData.splice(index, 1)
    },
    addTableData() {
      this.dialogData.push({ start_time: '', end_time: '', service_rate: '' })
    },
    dialogClose() {
      this.isShow = false
      this.dialogData = []
    },
    dialogConfirm() { // 新增和编辑都要使用这个提交接口
      const params = {
        cust_no: this.params.custNo,
        service_id: this.diaServiceId,
        sub_service_id: this.diaSubServiceId
      }
      const fee_list = this.dialogData.map(item => {
        return {
          start_time: item.start_time,
          end_time: item.end_time,
          rate: item.service_rate
        }
      })
      updateAccountFee(Object.assign({}, params, { fee_list: fee_list }))
        .then(res => {
          const { code } = res
          const message = res.msg
          if (code === 0) {
            this.isShow = false // 关闭弹框
            if (this.addFlag) {
              this.getDetail(this.publicParams.custNo)
            } else {
              this.getEditData()
            }
          } else {
            msg.call(this, message)
          }
        })
    },
    submit() {
      this.$refs.feeForm.validate(valid => {
        if (valid) {
          this.$router.go(-1)
        }
      })
    },
    getTime(str) {
      return new Date(str.split(' ')[0]).getTime()
    },
    checkStartData(event, index) {
      let TimeFlag = true
      if (this.dialogData.length && this.dialogData[index].end_time) {
        if (this.getTime(event) >= this.getTime(this.dialogData[index].end_time)) {
          TimeFlag = false
          this.$Message.info('有效期开始时间不能晚于结束时间')
          return TimeFlag
        }
      }
      if (this.dialogData.length) {
        this.dialogData.forEach((item, subIndex) => {
          if (subIndex !== index) {
            if (!(event < item.start_time || event > item.end_time)) {
              TimeFlag = false
            }
          }
        })
      }
      if (!TimeFlag) {
        this.$Message.info('时间不能有冲突')
      }
      return TimeFlag
    },
    checkEndData(event, index) {
      let TimeFlag = true
      if (this.dialogData.length && this.dialogData[index].start_time) {
        if (this.getTime(event) <= this.getTime(this.dialogData[index].start_time)) {
          TimeFlag = false
          this.$Message.info('有效期开始时间不能晚于结束时间')
          return TimeFlag
        }
      }
      if (this.dialogData.length) {
        this.dialogData.forEach((item, subIndex) => {
          if (subIndex !== index) {
            if (!(event < item.start_time || event > item.end_time)) {
              TimeFlag = false
            }
          }
        })
      }
      if (!TimeFlag) {
        msg.call(this, '时间不能有冲突')
      }
      return TimeFlag
    }
  }
}
</script>
<style lang="scss">
  .add_edit_free {
    width: 100%;
    .ivu-form {
      width: 800px;
      margin: 0 auto;
      padding: 30px;
      .ivu-form-item {
        margin-bottom: 5px;
        &.custName {
          .ivu-form-item-label::before {
            color: #FFF;
          }
        }
        &.fee {
          .ivu-form-item-error-tip {
            top: -90px;
            left: 700px;
          }
        }
      }
      .ivu-input {
        width: 220px;
      }
      .ivu-select {
        width: 220px;
        .ivu-select-dropdown {
          width: 220px;
          overflow-x: inherit;
          .ivu-select-item {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      .itemSpan {
        font-size: 12px;
      }
    }
  }
  .ivu-table {
    .ivu-table-row {
      height: 34px;
    }
  }
  .feeDialog {
    max-height: 700px;
    .leibie {
      color: #5D6F80;
      font-size: 12px;
      .right {
        margin-left: 40px;
      }
    }
    .add {
      margin-top: -10px;
      a {
        float: right;
      }
    }
    .ivu-table-wrapper {
      .line {
        display: inline-block;
        width: 18px;
        margin: 0 6px;
        border-bottom: 1px solid #E1E4F1;
        transform: translateY(-12px);
      }
    }
  }
</style>
